import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import SupportTopMenu from "./SupportTopMenu";

function EditTicketType() {
  const { id } = useParams();
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [ticketTypeName, setTicketTypeName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [timeStamp, setTimeStamp] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Edit Ticket Type";
    axios({
      method: "post",
      url: config.base_url + "Support/GetTicketTypeByIDAdmin",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, ID: parseInt(id, 10) },
    })
      .then((response) => {
        if (response.data.status_code === 1 && response.data.TicketType) {
          const row = response.data.TicketType;
          setTicketTypeName(row.TicketType || "");
          setIsActive(row.Is_Active !== false);
          setTimeStamp(row.TimeStamp || "");
        } else {
          toast.error(response.data.status_message || "Not found.");
        }
        setLoadingData(false);
      })
      .catch(() => {
        setLoadingData(false);
        toast.error("Network error.");
      });
  }, [id, AccessKey, UserID]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Support/SaveTicketType",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        ID: parseInt(id, 10),
        TicketType: ticketTypeName.trim(),
        Is_Active: isActive,
        TimeStamp: timeStamp,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
          navigate("/support/ticket-types");
        } else {
          toast.error(response.data.status_message || "Save failed.");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });

    setValidated(true);
  };

  return (
    <>
      <ToastContainer />
      <SupportTopMenu />
      <div className="page-head">
        <div className="container">
          <div className="page-title">Edit Ticket Type</div>
        </div>
      </div>
      <div className="container">
        <div className="card">
          <div className="card-body p-md-4">
            {loadingData ? (
              <Spinner animation="border" role="status" />
            ) : (
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row gy-3" style={{ maxWidth: "520px" }}>
                  <div className="col-12">
                    <label className="form-label">Department / Type name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ticketType"
                      maxLength={300}
                      value={ticketTypeName}
                      onChange={(e) => setTicketTypeName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <Form.Check
                      type="checkbox"
                      id="ticketTypeActiveEdit"
                      label="Active"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="button button-primary"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Update"}
                    </button>
                    <Link
                      to="/support/ticket-types"
                      className="button button-outline-primary ms-2"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditTicketType;
